import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Select, Store } from '@ngxs/store';
import { PilotPanelState } from '../../../store/dashboard/pilot-panel/pilot-panel.state';
import { TogglePilotPanel } from '../../../store/dashboard/pilot-panel/pilot-panel.actions';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-duotone-svg-icons';

@Component({
   selector: 'samweb-pilot-panel',
   templateUrl: './pilot-panel.component.html',
   styleUrls: ['./pilot-panel.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PilotPanelComponent implements OnInit {
   @Select(PilotPanelState.isPilotPanelExtended)
   public isPilotPanelExtended$: Observable<boolean>;

   public arrowLeftIcon: IconDefinition = faArrowLeft;
   public arrowRightIcon: IconDefinition = faArrowRight;

   constructor(private store: Store) {}

   ngOnInit() {}

   togglePilotPanel() {
      this.store.dispatch(new TogglePilotPanel());
   }
}
